export class Vehicle {
  year: number;
  model: string;
  make: string;
  vin: string;
  licensePlate: string;
  licenseState: string;
}
